import React from "react";
import { Moon, Sun, Languages } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";

const btn =
  "h-10 min-w-10 px-2.5 inline-flex items-center justify-center gap-1.5 rounded-full border bg-card/70 backdrop-blur text-sm font-semibold hover:bg-accent active:scale-95 transition-[transform,background-color] duration-200";

export const LangToggle = () => {
  const { t, toggleLang } = usePrefs();
  return (
    <button data-testid="lang-toggle-button" onClick={toggleLang} className={btn} aria-label="language">
      <Languages className="h-4 w-4" />
      <span className="hidden sm:inline">{t("lang.switch")}</span>
    </button>
  );
};

export const ThemeToggle = () => {
  const { theme, toggleTheme } = usePrefs();
  return (
    <button data-testid="theme-toggle-button" onClick={toggleTheme} className={btn} aria-label="theme">
      {theme === "dark" ? <Sun className="h-4 w-4 text-secondary" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
